import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryStockLocationSummary } from '@/renderer/services/inventoryStockLocationService';
import type { InventoryStockLocationFilterParams } from '@/renderer/types/inventory';

export function useInventoryStockLocationSummary(
  companyId: number | null | undefined,
  outletId: string | null | undefined,
  search: string,
  type: InventoryStockLocationFilterParams['type'],
  status: InventoryStockLocationFilterParams['status'],
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockLocationSummary(
      companyId ?? 0,
      outletId ?? '',
      search,
      type ?? 'all',
      status ?? 'all',
    ),
    queryFn: async () => {
      const result = await fetchInventoryStockLocationSummary(
        companyId ?? 0,
        outletId ?? '',
        search,
        type,
        status,
      );
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch inventory stock location summary',
        );
      }

      return result.data;
    },
    enabled: !!companyId && !!outletId,
  });
}
